'use client'

import React, { ReactElement, useEffect, useState } from 'react'
import { useWizardSelector } from '@/components/ui/wizard/WizardState'
import { useDispatch } from 'react-redux'
import DropDown from '@/components/ui/wizard/filter/DropDown'
import Modal from '@/components/common/Modal'
import FilterControlButtons from '@/components/ui/wizard/filter/FilterControlButtons'
import FilterLabel from '@/components/ui/wizard/filter/FilterLabel'
import { onMobileOrTablet } from '@/lib/utils/utils'
import { FilterModalType } from '@/lib/sharedConstants'
import { setOrder } from '@/components/ui/wizard/WizardActions'
import { useTranslations } from 'next-intl'
import RadioButtonWithLabel from '@/components/common/radio-button/RadioButtonWithLabel'

export const SORT_CRITERIA = ['price', 'rating', 'stars', 'popularity']

function Order(props: {
  setOrder: (i: number) => void
  orderLocalState: number | undefined
}): ReactElement {
  const translate = useTranslations('SearchPage.SortCriteria')

  return (
    <div className="mb-4 px-10 pt-8 lg:p-0 ">
      {onMobileOrTablet() && <FilterLabel label="SearchPage.labelSorting" />}
      {SORT_CRITERIA.map((c, i) => (
        <RadioButtonWithLabel
          checked={props.orderLocalState === i}
          value={i.toString()}
          labelValue={translate(c)}
          name="order"
          key={c}
          className="flex text-stone-800 lg:py-2"
          onChange={(event) => {
            if (event.target.checked) {
              props.setOrder(i)
            }
          }}
          id={c}
        />
      ))}
    </div>
  )
}

export function OrderDropdown(): ReactElement {
  const orderInStore = useWizardSelector((state) => state.order)
  const [orderLocalState, setOrderLocalStateLocalState] = useState(orderInStore)
  const dispatch = useDispatch()
  const t = useTranslations('SearchPage')

  return (
    <DropDown
      reset={() => setOrderLocalStateLocalState(undefined)}
      apply={() => dispatch(setOrder(orderLocalState))}
      resetLabel={t('filterOptionReset')}
      rightAligned={true}
      id="order"
    >
      <div className="mb-4 text-3xl font-medium text-stone-800">{t('labelSorting')}</div>
      <Order setOrder={(i) => setOrderLocalStateLocalState(i)} orderLocalState={orderLocalState} />
    </DropDown>
  )
}

export function OrderModal(props: {
  close: () => void
  type: FilterModalType | undefined
}): ReactElement {
  const orderInStore = useWizardSelector((state) => state.order)
  const [orderLocalState, setOrderLocalStateLocalState] = useState(orderInStore)
  const dispatch = useDispatch()
  const t = useTranslations('SearchPage')

  useEffect(() => {
    setOrderLocalStateLocalState(orderInStore)
  }, [orderInStore])

  function apply(): void {
    props.close()
    dispatch(setOrder(orderLocalState))
  }

  function reset(): void {
    setOrderLocalStateLocalState(undefined)
  }

  return (
    <Modal
      visible={props.type === FilterModalType.ORDER_MOBILE}
      close={props.close}
      mobileFullscreen={true}
      heading={<div>{t('menuSort')}</div>}
      classNameAdditionalBody="lg:max-h-[330px] md:left-0"
      additionalClassName={'h-full z-[101]'}
    >
      <Order setOrder={(i) => setOrderLocalStateLocalState(i)} orderLocalState={orderLocalState} />
      <FilterControlButtons reset={reset} apply={apply} resetLabel={t('filterOptionReset')} />
    </Modal>
  )
}
